HuesMdl.service( 'FanFilesSrv',['$http', '$q', 'API_URL', function( $http, $q, API_URL ) {

	return {
		getFanFiles: function( fan_id ) {
			var deffered = $q.defer();

			$http.get( API_URL.FAN + '/files/' + fan_id ).then(
				function ( response ){
					deffered.resolve( response.data );
				},
				function (error){
					deffered.reject(error);
				}
			)

			return deffered.promise;
		}
	}
}]);
